import { type BreakpointObserver } from '@angular/cdk/layout';
import { type DeviceStore } from '@sds/shared';
import { TailwindBasedBreakpoints, TailwindBreakpointAliases } from '@sds/shared/enums';
import { distinctUntilChanged, map } from 'rxjs/operators';

export function deviceMediaObserverInitializer(deviceStore: DeviceStore, breakpointObserver: BreakpointObserver) {
  return () => {
    return new Promise<void>(resolve => {
      const pointerCoarseQuery = '(pointer: coarse)';
      breakpointObserver
        .observe([...Object.values(TailwindBasedBreakpoints), pointerCoarseQuery])
        .pipe(
          map(result => {
            const activeBreakpoint = Object.keys(result.breakpoints).find(
              bp => result.breakpoints[bp] && bp !== pointerCoarseQuery
            );
            const isTouch: boolean = result.breakpoints[pointerCoarseQuery] ?? false;
            return {
              activeBreakpoint: usingObjectEntries(
                TailwindBasedBreakpoints,
                activeBreakpoint
              ) as TailwindBreakpointAliases,
              isTouch: isTouch
            };
          }),
          distinctUntilChanged((a, b) => a.activeBreakpoint === b.activeBreakpoint && a.isTouch === b.isTouch)
        )
        .subscribe(device => {
          deviceStore.setDevice(device.activeBreakpoint, device.isTouch);
          resolve();
        });
    });
  };
}

function usingObjectEntries(obj: typeof TailwindBasedBreakpoints, value?: string) {
  return !value ? TailwindBreakpointAliases.default : Object.entries(obj).find(([key, val]) => val === value)![0];
}
